/**
 * NAT 고급 설정 store
 *
 * @since 2018-07-23
 * @author kdydesign.kim
 */

import {SecutiryPolicyApiPrefix as apiPrefix} from 'utils'

const initNatAdData = () => {
  return {
    use: 1,
    chk_shadowed: 1,
    chk_src_dup: 1,
    ha_mmbr_use: 1,
    sync_nat_session: 1,
    del_all_session_on_apply: 1,
    server_chk_interval: 1,
    ip_alloc_method: 1,
    port_alloc_method: 1,
    psnat_cuseeme: 1,
    psnat_ftp: 1,
    psnat_h323: 1,
    psnat_irc: 1,
    psnat_mms: 1,
    psnat_netbios: 1,
    psnat_pptp: 1,
    psnat_rtsp: 1,
    psnat_tftp: 1,
    psnat_sqlnet: 1,
    psnat_sip: 1
  }
}

export const state = () => ({
  natAdData: initNatAdData(),
  orgNatAdData: initNatAdData()
})

export const mutations = {
  // NAT 고급 설정 조회
  getNatAdSettings (state, data) {
    state.natAdData = _.cloneDeep(data)
    state.orgNatAdData = _.cloneDeep(data)
  },

  // NAT 고급 설정 - 사용 변경
  saveNatAdUse (state, data) {
    state.natAdData.use = data.use
  },

  // NAT 고급 설정 적용
  applyNatAdSettings (state) {
    state.orgNatAdData = _.cloneDeep(state.natAdData)
  }
}

export const actions = {
  // NAT 고급 설정 - 사용 변경(NAT 정책 사용)
  async saveNatAdUse ({state, commit, dispatch}, {use}) {
    const {code, result} = await this.$axios.$put(`${apiPrefix}/nat/config`, {use})

    if (code === 'ok') {
      commit('saveNatAdUse', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // NAT 고급 설정 조회
  async getNatAdSettings ({commit}) {
    const {code, result} = await this.$axios.$get(`${apiPrefix}/nat/config`)

    if (code === 'ok') {
      commit('getNatAdSettings', result)
    }
  },

  // NAT 고급 설정 저장
  async saveNatAdSettings ({commit, state, dispatch}) {
    const {code, result} = await this.$axios.$put(`${apiPrefix}/nat/config`, state.natAdData, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      dispatch('applyNatAdSettings').then(() => {
        commit('getNatAdSettings', result)
      })
    }
  },

  // NAT 고급 설정 적용
  async applyNatAdSettings ({commit}) {
    const {code} = await this.$axios.$put(`${apiPrefix}/command/nat-config/apply`, void 0, {
      applyMsg: true,
      loadingShow: false
    })

    if (code === 'ok') {
      commit('applyNatAdSettings')
    }
  },

  // NAT 고급 설정 취소
  async cancelNatAdSettings ({dispatch}) {
    const {code} = await this.$axios.$put(`${apiPrefix}/command/nat-config/cancel`, void 0, {
      cancelMsg: true,
      loadingHide: false,
      loadingShow: false
    })

    if (code === 'ok') {
      dispatch('getNatAdSettings')
    }
  }
}

export const getters = {}

export const strict = false
